module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    staticClass: "contenedor-box"
  }, [_c('div', {
    staticClass: "box"
  }, [(!_vm.estoySiendoReemplazado) ? _c('form', [_c('div', {
    staticClass: "flex fdr space-evenly"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "reemplazante"
    }
  }, [_vm._v("Reemplazante")]), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigoReemplazante),
      expression: "codigoReemplazante"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.codigoReemplazante)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaReemplazante = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigoReemplazante = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.codigoReemplazante = ''
      }
    }
  }, [_vm._m(0)])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaReemplazante) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.codigoReemplazante
    },
    on: {
      "selected": _vm.seleccionarReemplazante,
      "close": function($event) {
        _vm.mostrarBusquedaReemplazante = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "fechaInicio"
    }
  }, [_vm._v("Fecha de Inicio")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaInicio),
      expression: "fechaInicio"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "min": _vm.getTodayDate()
    },
    domProps: {
      "value": (_vm.fechaInicio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaInicio = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "fechaFin"
    }
  }, [_vm._v("Fecha de Fin")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaFin),
      expression: "fechaFin"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaFin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaFin = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "field pt-20px"
  }, [_c('div', {
    staticClass: "control flex jcc"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._m(1), _c('span', [_vm._v("Guardar")])])])])]) : _vm._e(), (_vm.estoySiendoReemplazado) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("Ya estas siendo reemplazado por "), _c('strong', [_vm._v(_vm._s(_vm.nombreReemplazo))])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecb8cd44","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Asignar_Delegaciones.vue
// module id = 892
// module chunks = 0